import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../../styles/GlobalStyle.css'
import CustomFooter from '../../login/CustomFooter'
//import SubjectHistogram from '../../admin/SubjectHistogram'
//import SupportPieChartTiers from '../../admin/SupportPieChartTiers'
//import PersonAvatar from '../../customcomponents/PersonAvatar'
//import Empty from '../../customcomponents/Empty'
//import { getIDFromURL } from '../.././Util'
import { chunkArray, getAssessmentDisplayName, getQueryStringParam, getColorGradient, processHtmlWithScopedCss } from '../.././Util'
import { db } from '../../firebase/Firebase'
import ColType from '../.././Types'
import { Layout, Icon, Menu, Progress, Select, Button } from 'antd'
//import PacingGuideAssessment from './PacingGuideAssessment'
import DocumentDelegator from '../../edviz/EdvizDelegator'
import PersonAvatar from '../../customcomponents/PersonAvatar'
import DOKStandardBreakdown from '../../admin/DOKStandardBreakdown'
import ReactToPrint from "react-to-print"
import moment from 'moment'
import StudentSurveyResults from '../../admin/StudentSurveyResults'
import PrintableAssessment from './PrintableAssessment'
import HTMLAssessment from '../html/components/HTMLAssessment'
import HTMLAssessmentViewer from '../html/components/HTMLAssessmentViewer'
import StudentResource from './StudentResource'
const { Content } = Layout
const Option = Select.Option
//var moment = require('moment')

class PacingGuideTeacherAssessment extends Component {
    state = {
        assessmentId: '',
        selectedKeys: [],
        quiz: null,
        stats: {
            questionDataDict: {},
            questionData: [],
            questionsMostIncorrect: [],
            questionsMostCorrect: [],
            studentsCompleted: 0,
            studentsTotal: 0,
        },
        //statsRetrieved: false,
        statsCompleted: false,
        selectedStudentId: '',
        studentId: '',
    }

    componentDidMount() {
        document.title = 'Quiz - Dot It';
        let assessmentId = getQueryStringParam('assessment')
        this.setState({ assessmentId: assessmentId }, () => {
            this.getStats()

            let stateObj = {};
            let quiz = this.getAssessment(this.props)
            if (quiz) {
                stateObj.quiz = quiz
                stateObj.selectedKeys = this.isKindergartenOrFirstGrade(this.props) ? ['give-assessment'] : ['results']
            }
            this.setState(stateObj)
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.assessmentId) {
            let nextAssessment = this.getAssessment(nextProps)
            // use this.state.quiz as an initialization flag to set the selectedKeys
            if (!this.state.quiz && nextAssessment) {
                this.setState({
                    quiz: nextAssessment,
                    selectedKeys: this.isKindergartenOrFirstGrade(nextProps) ? ['give-assessment'] : ['results'],
                })
            }
        }

        this.getStats()
    }

    isKindergartenOrFirstGrade(props) {
        let assessment = this.getAssessment(props)
        if (assessment &&
            assessment.quiz &&
            assessment.quiz.hasOwnProperty('standardName')) {
            if (assessment.quiz.standardName === 'Kindergarten' ||
                assessment.quiz.standardName === '1st Grade') {
                return true
            }
        }
        return false
    }

    areChosenAnswersCorrect = (question, chosenAnswer) => {
        const questionAnswers = question.components[0].answers
        for (let answer of chosenAnswer.answer) {
            if (!questionAnswers[answer].correct) {
                return false
            }
        }
        return true
    }

    isChosenAnswerCorrect = (questionDoc, questionIdx, chosenAnswersBaseQuiz) => {
        let quiz = this.getAssessment(this.props)
        if (!quiz) {
            return false
        }

        if (quiz.quiz.hasOwnProperty('version') &&
            (quiz.quiz.version === '3.0' ||
                quiz.quiz.version === '4.0')
        ) {
            return chosenAnswersBaseQuiz[questionIdx];
        }

        const uuid = questionDoc.metadata.uuid
        if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
            return false
        }

        if (quiz && quiz.quiz && (quiz.quiz.standardName === 'Kindergarten' ||
            quiz.quiz.standardName === '1st Grade')
        ) {
            // checkbox so either true or false
            return chosenAnswersBaseQuiz[uuid]
        }

        const chosenAnswerBaseQuestionDocId = chosenAnswersBaseQuiz[uuid]
        for (let i = 0; i < questionDoc.components[0].answers.length; i++) {
            const answer = questionDoc.components[0].answers[i]
            if (answer.correct && answer.id === chosenAnswerBaseQuestionDocId) {
                return true
            }
        }
        return false
    }

    getChosenAnswerDocId = (questionDoc, chosenAnswersBaseQuiz) => {
        const uuid = questionDoc.metadata.uuid
        if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
            return -1
        }
        return chosenAnswersBaseQuiz[uuid]
    }

    numStudentsInDOKLevel = (quiz, dokLevel) => {
        if (!(quiz && dokLevel)) {
            return -1
        }
        if (quiz.quiz.numQuestions === 0) {
            return -1
        }
        let count = 0
        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            let studentGrade = quiz.studentGrades[studentId]
            if (quiz.hasOwnProperty('manualGrades') &&
                quiz.manualGrades &&
                quiz.manualGrades.hasOwnProperty(studentId)) {
                let manualGrade = quiz.manualGrades[studentId]
                // no automatic grade, use manual grade as it exists
                // manual grade has same structure as studentGrade
                if (!studentGrade.graded && manualGrade.graded) {
                    studentGrade = manualGrade
                }
            }
            let assessmentCompleted = studentGrade.graded

            let highestDOKLevel = 1
            if (assessmentCompleted) {
                const finalGrade = studentGrade.finalGrade.grade * 100
                const chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
                for (let i = 0; i < quiz.quiz.numQuestions; i++) {
                    const questionDoc = quiz.quiz.docs[i]
                    const dokLevel = questionDoc.metadata.dokLevel
                    const uuid = questionDoc.metadata.uuid
                    if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
                        continue
                    }
                    const correct = this.isChosenAnswerCorrect(questionDoc, i, chosenAnswersBaseQuiz)
                    if (correct) {
                        const dokLevelNumber = parseInt(dokLevel, 10)
                        if (dokLevelNumber > highestDOKLevel) {
                            if (dokLevelNumber === 2 && finalGrade >= 40) {
                                highestDOKLevel = dokLevelNumber
                            } else if (dokLevelNumber === 3 && finalGrade >= 60) {
                                highestDOKLevel = dokLevelNumber
                            }
                        }
                    }
                }
            }
            if (highestDOKLevel !== dokLevel) {
                return false
            }
            if (highestDOKLevel === dokLevel && assessmentCompleted) {
                count += 1
            }
            // dokLevel1 if not completed
            if (!assessmentCompleted && dokLevel === 1) {
                count += 1
            }
            return false
        })

        return count
    }

    getStats = () => {
        const quiz = this.getAssessment(this.props)
        if (!quiz) {
            return
        }
        if (quiz.quiz.numQuestions === 0) {
            return
        }
        if (!(this.props.teacherBaseProps &&
            this.props.teacherBaseProps.studentDict)) {
            return
        }
        //console.log('quiz', quiz)
        /*if (this.state.statsRetrieved) {
            return
        }

        this.setState({ statsRetrieved: true })*/

        let stats = {
            questionDataDict: {},
            questionData: [],
            questionsMostIncorrect: [],
            questionsMostCorrect: [],
            studentsCompleted: 0,
            studentsTotal: Object.keys(quiz.studentGrades).length,
        }

        Object.keys(quiz.studentGrades).map((studentId) => {
            if (!this.props.teacherBaseProps.studentDict.hasOwnProperty(studentId)) {
                return false
            }
            if (!quiz.studentGrades.hasOwnProperty(studentId)) {
                return false
            }
            const student = this.props.teacherBaseProps.studentDict[studentId]
            let studentGrade = quiz.studentGrades[studentId]
            if (quiz.hasOwnProperty('manualGrades') &&
                quiz.manualGrades &&
                quiz.manualGrades.hasOwnProperty(studentId)) {
                let manualGrade = quiz.manualGrades[studentId]
                // no automatic grade, use manual grade as it exists
                // manual grade has same structure as studentGrade
                if (!studentGrade.graded && manualGrade.graded) {
                    studentGrade = manualGrade
                }
            }
            let assessmentCompleted = studentGrade.graded
            let highestDOKLevel = 1
            if (assessmentCompleted) {
                stats.studentsCompleted += 1
                const chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
                for (let i = 0; i < quiz.quiz.numQuestions; i++) {
                    const questionDoc = quiz.quiz.docs[i]
                    let dokLevel = 1;
                    let uuid = i
                    let chosenAnswerIdx = -1
                    let chosenAnswerDocId = -1
                    if (quiz.quiz.hasOwnProperty('version') &&
                        (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {
                        dokLevel = 1
                        uuid = i
                        chosenAnswerIdx = 0
                    } else {
                        dokLevel = questionDoc.metadata.dokLevel
                        uuid = questionDoc.metadata.uuid
                        chosenAnswerDocId = this.getChosenAnswerDocId(questionDoc, chosenAnswersBaseQuiz)
                        for (let j = 0; j < questionDoc.components[0].answers.length; j++) {
                            if (questionDoc.components[0].answers[j].id === chosenAnswerDocId) {
                                chosenAnswerIdx = j
                                break
                            }
                        }
                    }
                    if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
                        continue
                    }
                    const correct = this.isChosenAnswerCorrect(questionDoc, i, chosenAnswersBaseQuiz)

                    if (correct) {
                        const dokLevelNumber = parseInt(dokLevel, 10)
                        if (dokLevelNumber > highestDOKLevel) {
                            highestDOKLevel = dokLevelNumber
                        }
                    }

                    if (!stats.questionDataDict.hasOwnProperty(i)) {
                        stats.questionDataDict[i] = {
                            correct: 0,
                            incorrect: 0,
                            total: 0,
                            chosen_answers: {
                                0: 0,
                                1: 0,
                                2: 0,
                                3: 0,
                            },
                        }
                    }
                    if (correct) {
                        stats.questionDataDict[i].correct += 1
                    } else {
                        stats.questionDataDict[i].incorrect += 1
                    }

                    if (chosenAnswerDocId !== -1) {
                        if (stats.questionDataDict[i].chosen_answers.hasOwnProperty(chosenAnswerIdx)) {
                            stats.questionDataDict[i].chosen_answers[chosenAnswerIdx] += 1
                        }
                    }
                    stats.questionDataDict[i].total += 1
                }
            }
        })

        for (let i = 0; i < quiz.quiz.numQuestions; i++) {
            if (!stats.questionDataDict.hasOwnProperty(i)) {
                stats.questionData.push({
                    questionIndex: i,
                    correct: 0,
                    incorrect: 0,
                    total: 0,
                })
                continue
            }
            const questionData = stats.questionDataDict[i]
            stats.questionData.push({
                questionIndex: i,
                correct: questionData.correct,
                incorrect: questionData.incorrect,
                total: questionData.total,
            })
        }

        stats.questionsMostIncorrect = Object.assign([], stats.questionData).sort((a, b) => {
            return b.incorrect - a.incorrect
        })
        stats.questionsMostCorrect = Object.assign([], stats.questionData).sort((a, b) => {
            return b.correct - a.correct
        })

        this.setState({
            stats: stats,
            statsCompleted: true,
        })
    }

    resultsForDOKLevel = (student, quiz, dokLevel) => {
        if (!(student && quiz && dokLevel)) {
            return false
        }
        if (quiz.quiz.numQuestions === 0) {
            return false
        }
        if (!quiz.studentGrades.hasOwnProperty(student.id)) {
            return false
        }
        let studentGrade = quiz.studentGrades[student.id]
        if (quiz.hasOwnProperty('manualGrades') &&
            quiz.manualGrades &&
            quiz.manualGrades.hasOwnProperty(student.id)) {
            let manualGrade = quiz.manualGrades[student.id]
            // no automatic grade, use manual grade as it exists
            // manual grade has same structure as studentGrade
            if (!studentGrade.graded && manualGrade.graded) {
                studentGrade = manualGrade
            }
        }
        let assessmentCompleted = studentGrade.graded
        let highestDOKLevel = 1
        if (assessmentCompleted) {
            console.log('studentGrade', studentGrade)
            const finalGrade = studentGrade.finalGrade.grade * 100
            const chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
            for (let i = 0; i < quiz.quiz.numQuestions; i++) {
                let questionDoc = null
                let dokLevel = 1
                let uuid = i
                if (quiz.quiz.hasOwnProperty('version') &&
                    (quiz.quiz.version === '3.0' || quiz.quiz.version === '4.0')) {

                } else {
                    questionDoc = quiz.quiz.docs[i]
                    dokLevel = questionDoc.metadata.dokLevel
                    uuid = questionDoc.metadata.uuid
                }

                if (!chosenAnswersBaseQuiz.hasOwnProperty(uuid)) {
                    continue
                }
                const correct = this.isChosenAnswerCorrect(questionDoc, i, chosenAnswersBaseQuiz)
                if (correct) {
                    const dokLevelNumber = parseInt(dokLevel, 10)
                    if (dokLevelNumber > highestDOKLevel) {
                        if (dokLevelNumber === 2 && finalGrade >= 40) {
                            highestDOKLevel = dokLevelNumber
                        } else if (dokLevelNumber === 3 && finalGrade >= 60) {
                            highestDOKLevel = dokLevelNumber
                        }
                    }
                }
            }
        }
        if (highestDOKLevel !== dokLevel) {
            return false
        }

        return <tr key={'tr-' + student.id}>
            <td>
                <PersonAvatar
                    person={student}
                    size={'large'}
                    containerClassName="font-20"
                    avatarClassName="font-20 font-bold mr-2"
                    personClassName="font-black font-24 ellipsis"
                    personStyle={{ maxWidth: '220px' }}
                />
            </td>
            <td>
                {assessmentCompleted ?
                    <div className='text-success font-bold'>
                        Completed
                    </div> :
                    <div className='text-blue font-bold'>In progress</div>
                }
            </td>
            <td>
                <div className='flex'>
                    {new Array(quiz.quiz.numQuestions).fill(0).map((mapQuestion, index) => {
                        let question = null
                        if (quiz.quiz.hasOwnProperty('version') &&
                            (quiz.quiz.version === '3.0' ||
                                quiz.quiz.version === '4.0')
                        ) {
                        } else {
                            question = quiz.quiz.docs[index]
                        }
                        let allCorrect = false
                        if (assessmentCompleted) {
                            let studentGrade = quiz.studentGrades[student.id]
                            if (quiz.hasOwnProperty('manualGrades') &&
                                quiz.manualGrades &&
                                quiz.manualGrades.hasOwnProperty(student.id)) {
                                let manualGrade = quiz.manualGrades[student.id]
                                // no automatic grade, use manual grade as it exists
                                // manual grade has same structure as studentGrade
                                if (!studentGrade.graded && manualGrade.graded) {
                                    studentGrade = manualGrade
                                }
                            }
                            if (studentGrade.hasOwnProperty('chosenAnswersBaseQuiz')) {
                                allCorrect = this.isChosenAnswerCorrect(question, index, studentGrade.chosenAnswersBaseQuiz)
                            }
                        }
                        let borderClasses = ' border-right border-top border-bottom'
                        if (index === 0) {
                            borderClasses += ' border-left br-tl-4 br-bl-4'
                        } else if (index === quiz.quiz.numQuestions - 1) {
                            borderClasses += ' br-tr-4 br-br-4'
                        }
                        return <div className={'p-1' + borderClasses} key={'assessment-' + student.id + index}>
                            {assessmentCompleted ?
                                allCorrect ?
                                    <Icon type='check' className='text-success' /> :
                                    <Icon type='close' className='text-danger' /> :
                                <div className='text-center' style={{ width: '20px' }}>-</div>}
                        </div>
                    })}
                </div>
            </td>
            <td>{assessmentCompleted ? (quiz.studentGrades[student.id].finalGrade.grade * 100) + '%' : '-'}</td>
        </tr>
    }

    getAssessment = (props) => {
        let assessment = null
        if (props.assessmentBaseProps &&
            this.state.assessmentId &&
            props.assessmentBaseProps.assessmentsDict &&
            props.assessmentBaseProps.assessmentsDict.hasOwnProperty(this.state.assessmentId) &&
            props.assessmentBaseProps.assessmentsDict[this.state.assessmentId]) {
            assessment = this.props.assessmentBaseProps.assessmentsDict[this.state.assessmentId]
        } else if (this.props.assessmentBaseProps &&
            this.state.assessmentId &&
            props.assessmentBaseProps.deletedAssessmentsDict &&
            props.assessmentBaseProps.deletedAssessmentsDict.hasOwnProperty(this.state.assessmentId) &&
            props.assessmentBaseProps.deletedAssessmentsDict[this.state.assessmentId]) {
            assessment = this.props.assessmentBaseProps.deletedAssessmentsDict[this.state.assessmentId]
        }
        return assessment
    }

    onReady = (event) => {
        // pass
        // console.log("on ready event", event);
    }

    onUpdate = (event) => {
        // console.log("on update event", event);
        let assessment = this.getAssessment(this.props);
        if (!assessment) {
            return;
        }
        if (!this.state.studentId) {
            return;
        }
        let updateObj = {
            'quizState': event.data,
        };
        if (event.data.survey) {
            updateObj['survey'] = {
                qualitative: event.data.survey,
                completed: true,
            };
        }
        let studentProgress = {};
        if (assessment.hasOwnProperty('studentProgress') && assessment.studentProgress) {
            studentProgress = assessment.studentProgress;
        }
        studentProgress[this.state.studentId] = updateObj;
        console.log('update', this.state.studentId, updateObj, assessment.studentProgress, studentProgress);

        let quizUpdateObj = {};
        quizUpdateObj['studentProgress'] = studentProgress;

        db.collection(ColType.cleverAssessments)
            .doc(assessment.id)
            .update(quizUpdateObj)
            .then(() => {
                console.log('quiz updated successfully')
            })
            .catch((error) => {
                console.log('error submitting quiz', error)
            })
    }

    onSubmit = (event) => {
        // console.log("on submit event", event);
        let assessment = this.getAssessment(this.props);
        if (!assessment) {
            return;
        }
        if (!this.state.studentId) {
            return;
        }

        const quizResults = event.data.submission.results;
        const survey = {
            qualitative: event.data.survey,
            completed: true,
        };
        let updateObj = {
            // current state of the quiz based on what has been
            // selected or answered so far
            'quizState': event.data,
            // quiz results, this is the final results of the quiz
            'quizResults': quizResults,
            'survey': survey,
        };

        let studentProgress = {};
        if (assessment.hasOwnProperty('studentProgress') && assessment.studentProgress) {
            studentProgress = assessment.studentProgress;
        }
        studentProgress[this.state.studentId] = updateObj;

        let quizUpdateObj = {};
        quizUpdateObj['studentProgress'] = studentProgress;

        let chosenAnswers = {};
        let chosenAnswersForBaseQuiz = {};
        // ['q1', 'q2', 'q3', etc] are the questionKeys
        // localeCompare with numeric: true handles q1, q9, q10, etc
        // regular sort has q1, q10, q9, etc i.e incorrect basically
        // works as expected
        let questionKeys = Object.keys(quizResults.results).sort((a, b) => {
            return a.localeCompare(b, undefined, { numeric: true });
        });
        questionKeys.map((questionKey, questionKeyIdx) => {
            const questionResult = quizResults.results[questionKey];
            chosenAnswers[questionKeyIdx] = questionResult.isCorrect;
            chosenAnswersForBaseQuiz[questionKeyIdx] = questionResult.isCorrect;
        });
        let correct = quizResults.score
        let total = quizResults.total
        let grade = 0
        if (correct > 0 && total > 0) {
            grade = correct / total
        }
        const finalGrade = {
            chosenAnswers: chosenAnswers,
            chosenAnswersBaseQuiz: chosenAnswersForBaseQuiz,
            finalGrade: {
                "correct": correct,
                "grade": grade,
                "total": total
            },
            graded: true,
        }

        quizUpdateObj['studentGrades.' + this.state.studentId] = finalGrade;
        quizUpdateObj['studentSurveys.' + this.state.studentId] = survey;

        db.collection(ColType.cleverAssessments)
            .doc(assessment.id)
            .update(quizUpdateObj)
            .then(() => {
                console.log('quiz submitted successfully');
                this.getStats();
            })
            .catch((error) => {
                console.log('error submitting quiz', error)
            });
    }

    studentChange = (value) => {
        this.setState({
            studentId: value,
        });
    }

    render() {
        let assessment = this.getAssessment(this.props)
        let assessmentTitle = ''
        if (assessment) {
            assessmentTitle = getAssessmentDisplayName(assessment.quiz)
            if (assessment.quiz.hasOwnProperty('assessmentTitle')) {
                assessmentTitle = assessment.quiz.assessmentTitle
            } else if (assessment.quiz.assessmentCategory === 'quiz') {
                assessmentTitle = assessment.quiz.standard.standard + ' Quiz'
            } else if (assessment.quiz.assessmentCategory === 'common_assessment') {
                if (assessment.quiz.hasOwnProperty('standards') && assessment.quiz.standards && assessment.quiz.standards.length > 0) {
                    assessmentTitle = assessment.quiz.standards[0].standardCategory + ' ' + assessmentTitle
                }
            } else if (assessment.quiz.assessmentCategory === 'benchmark') {
                if (assessment.quiz.hasOwnProperty('standards') && assessment.quiz.standards && assessment.quiz.standards.length > 0) {
                    assessmentTitle = assessment.quiz.standards[0].standardCategory + ' ' + assessmentTitle
                }
            }
        }

        return (
            <div>
                <Layout className="content">
                    <Layout className="mt-0">
                        <Layout.Sider
                            width={270}
                            style={{
                                overflow: 'auto', overflowX: 'hidden', height: 'calc(100% - 82px)',
                                position: 'fixed',
                                left: 0, marginTop: '82px', borderRight: '1px solid #eef2f7',
                                background: '#fff', borderTop: '1px solid #eef2f7',
                                zIndex: 10,
                            }}>
                            <Menu className='font-20 menu-vlg-2 pt-4 border-right-none'
                                selectedKeys={this.state.selectedKeys}
                                onSelect={(e) => {
                                    this.setState({
                                        selectedKeys: [e.key]
                                    }, () => {
                                        window.scrollTo(0, 0)
                                    })
                                }}
                            >
                                {this.isKindergartenOrFirstGrade(this.props) ?
                                    <Menu.Item key="give-assessment">
                                        <div className="font-20 flex-v-center w-100">
                                            <Icon type="solution" className="font-24" style={{ color: '#2d6a9f' }} />
                                            <span>Give assessment</span>
                                        </div>
                                    </Menu.Item>
                                    : ''}
                                <Menu.Item key="results">
                                    <div className="font-20 flex-v-center w-100">
                                        <Icon type="solution" className="font-24" style={{ color: '#2d6a9f' }} />
                                        <span>Class Report</span>
                                    </div>
                                </Menu.Item>
                                <Menu.Item key="analytics">
                                    <div className="font-20 flex-v-center w-100">
                                        <Icon type="bar-chart" className="font-24" style={{ color: '#2d6a9f' }} />
                                        <span>
                                            Question Analytics
                                        </span>
                                    </div>
                                </Menu.Item>
                                <Menu.Item key="questions">
                                    <div className="font-20 flex-v-center w-100">
                                        <Icon type="ordered-list" className="font-24" style={{ color: '#2d6a9f' }} />
                                        <span>
                                            Question Answers
                                        </span>
                                    </div>
                                </Menu.Item>
                                {!this.isKindergartenOrFirstGrade(this.props) ?
                                    <Menu.Item key="print-test">
                                        <div className="font-20 flex-v-center w-100">
                                            <Icon type="printer" className="font-24" style={{ color: '#2d6a9f' }} />
                                            <span>
                                                Printable Quiz
                                            </span>
                                        </div>
                                    </Menu.Item> : ''}
                                {!this.isKindergartenOrFirstGrade(this.props) ?
                                    <Menu.Item key="print-reports">
                                        <div className="font-20 flex-v-center w-100">
                                            <Icon type="printer" className="font-24" style={{ color: '#2d6a9f' }} />
                                            <span>
                                                Print Student Report
                                            </span>
                                        </div>
                                    </Menu.Item> : ''}
                            </Menu>
                        </Layout.Sider>
                        <Layout.Content style={{
                            marginLeft: 269, marginTop: "80px", overflowX: 'initial'
                        }}
                            className='pt-1 background-light-grey-important'
                        >
                            <div className="mt-4 pt-1 pb-2">
                                <div>
                                    {this.props.teacherBaseProps &&
                                        this.props.teacherBaseProps.teacher &&
                                        assessment ?
                                        <div className='mb-3 font-16 sticky-left sticky-left-more display-table'>
                                            <div className='flex flex-v-center'>
                                                <Link to={'/teacher/quizzes/all/' + this.props.teacherBaseProps.teacher.id} scroll={false}>
                                                    <div className='font-16' style={{ color: '#2d6a9f', fontWeight: 700 }}>Quizzes</div>
                                                </Link>
                                                <Icon type='right' className='ml-1 mr-1 font-16' style={{ color: '#94a3b8' }} />
                                                <div style={{ color: '#475569' }}>{assessmentTitle + (this.state.selectedKeys.length > 0 ?
                                                    this.state.selectedKeys[0] === 'results' ?
                                                        ' - Class Report' :
                                                        this.state.selectedKeys[0] === 'questions' ?
                                                            ' - Question Answers' :
                                                            this.state.selectedKeys[0] === 'analytics' ?
                                                                ' - Question Analytics' : '' : '')}</div>
                                                {assessment.hasOwnProperty('timeStamp') &&
                                                    assessment.timeStamp &&
                                                    assessment.timeStamp.hasOwnProperty('seconds') ?
                                                    <div className='flex flex-v-center'>
                                                        <Icon type='right' className='ml-1 mr-1 font-16' style={{ color: '#94a3b8' }} />
                                                        <div style={{ color: '#94a3b8' }}>{moment.utc(assessment.timeStamp.seconds * 1000).format("MM/DD/YYYY")}</div>
                                                    </div>
                                                    : ''}
                                            </div>
                                        </div>
                                        : ''}
                                </div>
                                {this.state.selectedKeys.length > 0 &&
                                    this.state.selectedKeys[0] === 'give-assessment' &&
                                    assessment &&
                                    assessment.quiz ?
                                    <div>
                                        <div className='w-1000 m-lr-auto mb-3 mt-3'>
                                            {/* Friendly info banner */}
                                            <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
                                                <Icon type='solution' style={{ fontSize: 34, color: '#2d6a9f' }} />
                                                <div>
                                                    <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>Give the assessment</div>
                                                    <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>Pick a student from the list below to read the assessment to them and record their answers.</div>
                                                </div>
                                            </div>
                                            {!this.state.studentId ?
                                                <div style={{ fontSize: 18, fontWeight: 700, color: '#1e293b', marginBottom: 8 }}>Select a student to get started:</div>
                                                :
                                                <div style={{ fontSize: 18, fontWeight: 700, color: '#1e293b', marginBottom: 8 }}>Student:</div>
                                            }
                                            <Select
                                                showSearch
                                                className="ant-select-very-large"
                                                placeholder="Select student"
                                                style={{ width: '300px' }}
                                                value={this.state.studentId ? this.state.studentId : undefined}
                                                onChange={this.studentChange}
                                            >
                                                {this.props.teacherBaseProps && this.props.teacherBaseProps.students &&
                                                    this.props.teacherBaseProps.studentDict &&
                                                    assessment && assessment.studentGrades &&
                                                    this.props.teacherBaseProps.students.map((student, index) => {
                                                        const studentId = student.id;
                                                        if (!this.props.teacherBaseProps.studentDict.hasOwnProperty(studentId)) {
                                                            return null
                                                        }
                                                        return <Option value={student.id} key={"student-" + index}>
                                                            <div className='flex flex-v-center w-100'>
                                                                <PersonAvatar
                                                                    size={'default'}
                                                                    person={student}
                                                                />
                                                                {assessment.studentGrades &&
                                                                    assessment.studentGrades[studentId] &&
                                                                    assessment.studentGrades[studentId].graded ?
                                                                    <div className='ml-auto'>
                                                                        <Icon type="check" className='text-success'
                                                                            title={'Completed'} />
                                                                    </div>
                                                                    : ''}
                                                            </div>
                                                        </Option>
                                                    })
                                                }
                                            </Select>
                                        </div>
                                        <div className='flex flex-h-center w-100'>
                                            {assessment && this.state.studentId ?
                                                <StudentResource
                                                    key={`assessment-${this.state.studentId}`}
                                                    savedState={
                                                        assessment.studentProgress &&
                                                            assessment.studentProgress[this.state.studentId] ? {
                                                            ...assessment.studentProgress[this.state.studentId].quizState,
                                                            results: assessment.studentProgress[this.state.studentId].quizResults
                                                        } : undefined
                                                    }
                                                    htmlSource={assessment.quiz.docs}
                                                    onReady={this.onReady}
                                                    onUpdate={this.onUpdate}
                                                    onSubmit={this.onSubmit}
                                                /> : ''}
                                        </div>
                                    </div>
                                    : ''}
                                {this.state.selectedKeys.length > 0 &&
                                    this.state.selectedKeys[0] === 'results' ?
                                    <div className='pl-2 pr-2'>
                                        {/* Gradient hero banner */}
                                        <div className='relative mb-4'>
                                            <div className='w-100 br-20 overflow-hidden'
                                                style={{ height: '220px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }} />
                                            <div className='absolute-tl w-100 h-100 p-4 flex flex-v-center'>
                                                <div>
                                                    <div className='font-40 font-bold font-fff'>Class Report</div>
                                                    <div className='font-24 font-fff mt-1'>{assessmentTitle}</div>
                                                    {assessment && assessment.hasOwnProperty('timeStamp') &&
                                                        assessment.timeStamp &&
                                                        assessment.timeStamp.hasOwnProperty('seconds') ?
                                                        <div className='font-20 font-fff mt-1' style={{ opacity: 0.85 }}>{moment.utc(assessment.timeStamp.seconds * 1000).format("MM/DD/YYYY")}</div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        {/* Friendly info banner */}
                                        <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
                                            <Icon type='solution' style={{ fontSize: 34, color: '#2d6a9f' }} />
                                            <div>
                                                <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>How your class did</div>
                                                <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>This report breaks down results by standard and shows each student's progress on the assessment.</div>
                                            </div>
                                        </div>
                                        {assessment &&
                                            this.props.teacherBaseProps.students &&
                                            this.props.teacherBaseProps.studentDict ?
                                            <div>
                                                {assessment &&
                                                    assessment.hasOwnProperty('studentSurveys') &&
                                                    assessment.studentSurveys ?
                                                    <div className='mb-4 ml-3 flex'>
                                                        <div>
                                                            <StudentSurveyResults
                                                                studentSurveys={assessment.studentSurveys}
                                                                manualGrades={assessment.hasOwnProperty('manualGrades') ?
                                                                    assessment.manualGrades : null
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    : ''}
                                                <DOKStandardBreakdown
                                                    parentQuiz={assessment.quiz}
                                                    quiz={assessment}
                                                    students={this.props.teacherBaseProps.students}
                                                    studentDict={this.props.teacherBaseProps.studentDict}
                                                    onlyShowCompleted={false}
                                                    showProgress={true}
                                                />
                                            </div>
                                            : ''}
                                    </div>
                                    : ''}
                                {this.state.selectedKeys.length > 0 &&
                                    this.state.selectedKeys[0] === 'questions' ?
                                    <div className='pl-2 pr-2'>
                                        <div className='relative mb-4'>
                                            <div className='w-100 br-20 overflow-hidden'
                                                style={{ height: '220px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }} />
                                            <div className='absolute-tl w-100 h-100 p-4 flex flex-v-center'>
                                                <div>
                                                    <div className='font-40 font-bold font-fff'>Question Answers</div>
                                                    <div className='font-24 font-fff mt-1'>{assessmentTitle}</div>
                                                    {assessment && assessment.hasOwnProperty('timeStamp') &&
                                                        assessment.timeStamp &&
                                                        assessment.timeStamp.hasOwnProperty('seconds') ?
                                                        <div className='font-20 font-fff mt-1' style={{ opacity: 0.85 }}>{moment.utc(assessment.timeStamp.seconds * 1000).format("MM/DD/YYYY")}</div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        {/* Friendly info banner */}
                                        <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
                                            <Icon type='ordered-list' style={{ fontSize: 34, color: '#2d6a9f' }} />
                                            <div>
                                                <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>The answer key</div>
                                                <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>Every question on this assessment is shown below with its correct answer and the standard it covers.</div>
                                            </div>
                                        </div>
                                        {assessment && assessment.quiz && assessment.quiz.hasOwnProperty('version') &&
                                            (assessment.quiz.version === '3.0' ||
                                                assessment.quiz.version === '4.0') ?
                                            <div className='w-1000 m-lr-auto'>
                                                <StudentResource
                                                    savedState={{ showAllCorrectAnswers: true, survey: 'good' }}
                                                    htmlSource={assessment.quiz.docs} />
                                            </div> :
                                            <div className='mt-2 pr-3 question-container background-fully-transparent'>
                                                {assessment && assessment.quiz.docs.map((lessonPlanItem, idx) => {
                                                    return <div className='font-black font-20 ant-shadow br-15 p-4 mb-50' key={'assessment-idx-' + idx}>
                                                        <div className='font-24 font-bold mb-2' style={{ color: '#1e293b' }}>Question {idx + 1}</div>
                                                        <DocumentDelegator
                                                            document={lessonPlanItem}
                                                        />
                                                        {lessonPlanItem ?
                                                            <div className='mt-4'>
                                                                <div className='font-16 font-bold' style={{ color: '#1e293b' }}>
                                                                    Question is for standard: {lessonPlanItem.metadata.standard.standard}
                                                                </div>
                                                                {lessonPlanItem.metadata.standard.hasOwnProperty('isPriority') &&
                                                                    lessonPlanItem.metadata.standard.isPriority ?
                                                                    <div className='font-16' style={{ color: '#475569' }}>*Priority Standard</div>
                                                                    : ''}
                                                                <div className='mt-1 font-16' style={{ color: '#475569' }}>{lessonPlanItem.metadata.standard.title}</div>
                                                            </div>
                                                            : ''}
                                                    </div>
                                                })}
                                            </div>}
                                    </div> : ''}
                                {this.state.selectedKeys.length > 0 &&
                                    this.state.selectedKeys[0] === 'analytics' ?
                                    <div className='pl-2 pr-2'>
                                        <div className='relative mb-4'>
                                            <div className='w-100 br-20 overflow-hidden'
                                                style={{ height: '220px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }} />
                                            <div className='absolute-tl w-100 h-100 p-4 flex flex-v-center'>
                                                <div>
                                                    <div className='font-40 font-bold font-fff'>Question Analytics</div>
                                                    <div className='font-24 font-fff mt-1'>{assessmentTitle}</div>
                                                    {assessment && assessment.hasOwnProperty('timeStamp') &&
                                                        assessment.timeStamp &&
                                                        assessment.timeStamp.hasOwnProperty('seconds') ?
                                                        <div className='font-20 font-fff mt-1' style={{ opacity: 0.85 }}>{moment.utc(assessment.timeStamp.seconds * 1000).format("MM/DD/YYYY")}</div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        {/* Friendly info banner */}
                                        <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
                                            <Icon type='bar-chart' style={{ fontSize: 34, color: '#2d6a9f' }} />
                                            <div>
                                                <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>Where students struggled</div>
                                                <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>Each box shows the percent of students who answered that question correctly. Green is strong, red needs review.</div>
                                            </div>
                                        </div>
                                        <div className='mt-2'>
                                            <div className='font-24 text-center' style={{ color: '#1e293b' }}>Students completed: {this.state.stats.studentsCompleted} / {this.state.stats.studentsTotal} {'(' + (this.state.stats.studentsTotal > 0 ? ((this.state.stats.studentsCompleted / this.state.stats.studentsTotal) * 100).toFixed(2) : '-') + '%)'}</div>
                                            {assessment && this.state.statsCompleted ?
                                                <div>
                                                    <div className='mb-2 pb-05 pt-2'>
                                                        {chunkArray(new Array(assessment.quiz.numQuestions).fill(0), 10).map((chunk, chunkIndex) => {
                                                            return <div className='flex flex-v-center flex-h-center w-100 pt-1'>
                                                                {chunk.map((lessonPlanItem, questionIndex) => {
                                                                    const oneDimIndex = (chunkIndex * 10) + questionIndex
                                                                    let borderClasses = ' border-right border-top border-bottom'
                                                                    if (questionIndex === 0) {
                                                                        borderClasses += ' border-left br-tl-4 br-bl-4'
                                                                    } else if (questionIndex === assessment.quiz.docs.length - 1) {
                                                                        borderClasses += ' br-tr-4 br-br-4'
                                                                    }
                                                                    if (!this.state.stats.questionDataDict.hasOwnProperty(oneDimIndex)) {
                                                                        return false
                                                                    }
                                                                    const questionData = this.state.stats.questionDataDict[oneDimIndex]
                                                                    const correct = questionData.correct
                                                                    const incorrect = questionData.incorrect
                                                                    const total = questionData.total
                                                                    const correctPctNumber = (total > 0 ? ((correct / total) * 100) : 0)
                                                                    const correctPct = (total > 0 ? ((correct / total) * 100).toFixed(2) : 0)
                                                                    let background = '#fff'
                                                                    if (correctPctNumber < 30) {
                                                                        background = '#ffccc7'
                                                                    } else if (correctPctNumber < 60) {
                                                                        background = '#ffe7ba'
                                                                    } else if (correctPctNumber) {
                                                                        background = '#d9f7be'
                                                                    }
                                                                    return <div key={'assessment-total-' + oneDimIndex}>
                                                                        <div className='font-16 text-center mb-05' style={{ color: '#475569' }}>{'Q' + (oneDimIndex + 1)}</div>
                                                                        <div className={'p-1' + borderClasses} style={{ background: getColorGradient(correctPctNumber) }}>
                                                                            <div className='text-center font-16' style={{ width: '65px' }}>
                                                                                {total > 0 ? correctPct + '%' : '-'}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                })}
                                                            </div>
                                                        })}
                                                    </div>
                                                    <div className={'background-fully-transparent w-1000 m-lr-auto'}>
                                                        {this.state.stats.studentsCompleted === 0 ?
                                                            <div className='font-24 text-center' style={{ color: '#475569' }}>
                                                                No students have completed this assessment yet.
                                                            </div> : ''}
                                                        {this.state.stats.questionData.map((questionStats, idx) => {
                                                            const questionIdx = questionStats.questionIndex
                                                            const lessonPlanItem = assessment.quiz.docs[questionIdx]
                                                            if (!this.state.stats.questionDataDict.hasOwnProperty(questionIdx)) {
                                                                return false
                                                            }
                                                            const questionData = this.state.stats.questionDataDict[questionIdx]
                                                            //console.log(questionData)
                                                            const correct = questionData.correct
                                                            const incorrect = questionData.incorrect
                                                            const total = questionData.total
                                                            const correctPctNumber = (total > 0 ? ((correct / total) * 100) : 0)
                                                            const correctPct = (total > 0 ? parseFloat(((correct / total) * 100).toFixed(2)) : 0)
                                                            const incorrectPct = (total > 0 ? parseFloat(((incorrect / total) * 100).toFixed(2)) : 0)
                                                            let progressBarClassName = ''
                                                            if (correctPctNumber < 30) {
                                                                progressBarClassName = 'progress-light-red'
                                                            } else if (correctPctNumber < 60) {
                                                                progressBarClassName = 'progress-light-yellow'
                                                            } else if (correctPctNumber) {
                                                                progressBarClassName = 'progress-light-green'
                                                            }
                                                            return <div key={'most-incorrect-' + idx} className='font-black font-20 ant-shadow br-15 p-4 mb-50'>
                                                                <div className='font-24 font-bold mb-2' style={{ color: '#1e293b' }}>Question {questionIdx + 1}</div>
                                                                <div className='font-20' style={{ color: '#475569' }}>{correct} / {total} ({correctPct}%) students answered this question correctly</div>
                                                                <div className='pr-12px'>
                                                                    <Progress size='large'
                                                                        percent={correctPct}
                                                                        className={progressBarClassName} />
                                                                </div>
                                                                {!assessment.quiz.hasOwnProperty('htmlQuiz') &&
                                                                    !(assessment.quiz.hasOwnProperty('version') &&
                                                                        (assessment.quiz.version === '3.0' ||
                                                                            assessment.quiz.version === '4.0')
                                                                    ) ?
                                                                    <div>
                                                                        <div className='mt-4'>
                                                                            <DocumentDelegator
                                                                                document={lessonPlanItem}
                                                                                additionalData={{ questionStats: questionData }}
                                                                            />
                                                                        </div>
                                                                        {lessonPlanItem && lessonPlanItem.metadata.standard ?
                                                                            <div className='mt-4'>
                                                                                <div className='font-16 font-bold' style={{ color: '#1e293b' }}>
                                                                                    This question is for the standard: {lessonPlanItem.metadata.standard.standard}
                                                                                </div>
                                                                                {lessonPlanItem.metadata.standard.hasOwnProperty('isPriority') &&
                                                                                    lessonPlanItem.metadata.standard.isPriority ?
                                                                                    <div className='font-16' style={{ color: '#475569' }}>*Priority Standard</div>
                                                                                    : ''}
                                                                                <div className='mt-1 font-16' style={{ color: '#475569' }}>{lessonPlanItem.metadata.standard.title}</div>
                                                                            </div>
                                                                            : ''}
                                                                    </div> : ''}
                                                            </div>
                                                        })}
                                                        {assessment.quiz.hasOwnProperty('version') &&
                                                            (assessment.quiz.version === '3.0' ||
                                                                assessment.quiz.version === '4.0') ?
                                                            <div className='mt-50'>
                                                                <StudentResource
                                                                    savedState={{ showAllCorrectAnswers: true, survey: 'good' }}
                                                                    htmlSource={assessment.quiz.docs} />
                                                            </div> : ''}
                                                    </div>
                                                </div> : ''}
                                        </div>
                                    </div> : ''}
                                {this.state.selectedKeys.length > 0 &&
                                    this.state.selectedKeys[0] === 'print-reports' ?
                                    <div className='pl-2 pr-2'>
                                        <div className='relative mb-4'>
                                            <div className='w-100 br-20 overflow-hidden'
                                                style={{ height: '220px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }} />
                                            <div className='absolute-tl w-100 h-100 p-4 flex flex-v-center'>
                                                <div>
                                                    <div className='font-40 font-bold font-fff'>Print Student Report</div>
                                                    <div className='font-24 font-fff mt-1'>{assessmentTitle}</div>
                                                    {assessment && assessment.hasOwnProperty('timeStamp') &&
                                                        assessment.timeStamp &&
                                                        assessment.timeStamp.hasOwnProperty('seconds') ?
                                                        <div className='font-20 font-fff mt-1' style={{ opacity: 0.85 }}>{moment.utc(assessment.timeStamp.seconds * 1000).format("MM/DD/YYYY")}</div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mt-2 pr-3 w-800 m-lr-auto background-fully-transparent'>
                                            {/* Friendly info banner */}
                                            <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
                                                <Icon type='printer' style={{ fontSize: 34, color: '#2d6a9f' }} />
                                                <div>
                                                    <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>Print one student's report</div>
                                                    <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>Choose a student who finished the quiz, then click Print to print the report.</div>
                                                </div>
                                            </div>
                                            <div className='flex flex-v-center mb-3 w-100'>
                                                <div>
                                                    <div className='font-16 mb-05' style={{ color: '#1e293b', fontWeight: 700 }}>Select a student:</div>
                                                    <Select size='large' style={{ width: '300px' }}
                                                        value={this.state.selectedStudentId ? this.state.selectedStudentId : undefined}
                                                        placeholder="Select student..." onChange={(e) => {
                                                            this.setState({
                                                                selectedStudentId: e,
                                                            })
                                                        }}>
                                                        {assessment && Object.keys(assessment.studentGrades).map((studentId, idx) => {
                                                            if (!(this.props.teacherBaseProps &&
                                                                this.props.teacherBaseProps.studentDict)) {
                                                                return false
                                                            }
                                                            if (!this.props.teacherBaseProps.studentDict.hasOwnProperty(studentId)) {
                                                                return false
                                                            }
                                                            let studentGrade = assessment.studentGrades[studentId]
                                                            if (assessment.hasOwnProperty('manualGrades') &&
                                                                assessment.manualGrades &&
                                                                assessment.manualGrades.hasOwnProperty(studentId)) {
                                                                let manualGrade = assessment.manualGrades[studentId]
                                                                // no automatic grade, use manual grade as it exists
                                                                // manual grade has same structure as studentGrade
                                                                if (!studentGrade.graded && manualGrade.graded) {
                                                                    studentGrade = manualGrade
                                                                }
                                                            }
                                                            if (!studentGrade.graded) {
                                                                return false
                                                            }
                                                            const student = this.props.teacherBaseProps.studentDict[studentId]
                                                            return <Select.Option key={'student-' + idx} value={studentId}>
                                                                <PersonAvatar
                                                                    person={student}
                                                                    size={'large'}
                                                                    containerClassName="font-20"
                                                                    avatarClassName="font-20 font-bold mr-2"
                                                                    personClassName="font-black font-20 ellipsis"
                                                                />
                                                            </Select.Option>
                                                        })}
                                                    </Select>
                                                </div>
                                                <ReactToPrint
                                                    trigger={() =>
                                                        <Button
                                                            size={'large'}
                                                            type='primary'
                                                            className="btn-vl ml-auto"
                                                            disabled={!this.state.selectedStudentId}
                                                        >
                                                            <Icon type="printer" />
                                                            Print
                                                        </Button>
                                                    }
                                                    content={() => this.componentRef}
                                                />
                                            </div>
                                            {!this.state.selectedStudentId ?
                                                <div className='mt-50 font-20 p-3 flex w-100'
                                                    style={{ background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, color: '#475569' }}>
                                                    <div>
                                                        Select a student above to get a printable student report.<br />Only students who have completed this assessment can be selected.
                                                    </div>
                                                </div>
                                                : ''}
                                            <div ref={el => (this.componentRef = el)}>
                                                {assessment &&
                                                    this.state.selectedStudentId &&
                                                    this.props.teacherBaseProps &&
                                                    this.props.teacherBaseProps.studentDict &&
                                                    this.props.teacherBaseProps.studentDict.hasOwnProperty(this.state.selectedStudentId) &&
                                                    this.props.teacherBaseProps.studentDict[this.state.selectedStudentId] ?
                                                    <div className='mb-2'>
                                                        <div className='font-30 font-bold' style={{ color: '#1e293b' }}>
                                                            {this.props.teacherBaseProps.studentDict[this.state.selectedStudentId].firstName}'s Assessment Report
                                                        </div>
                                                        <div className='font-24' style={{ color: '#475569' }}>
                                                            {assessment.hasOwnProperty('timeStamp') &&
                                                                assessment.timeStamp &&
                                                                assessment.timeStamp.hasOwnProperty('seconds') &&
                                                                assessment.timeStamp.seconds ?
                                                                moment.utc(assessment.timeStamp.seconds * 1000).format('MM/DD/YYYY') : ''}
                                                        </div>
                                                    </div>
                                                    : ''}
                                                {assessment && assessment.quiz.hasOwnProperty('version') &&
                                                    (assessment.quiz.version === '3.0' ||
                                                        assessment.quiz.version === '4.0') ?
                                                    <div>
                                                        <div>
                                                            {this.state.selectedStudentId ?
                                                                <div className='font-black font-20 border br-15 p-4 mb-4'>
                                                                    {this.state.selectedStudentId && new Array(assessment.quiz.numQuestions).fill(0).map((_, idx) => {
                                                                        let studentGrade = assessment.studentGrades[this.state.selectedStudentId]
                                                                        if (assessment.hasOwnProperty('manualGrades') &&
                                                                            assessment.manualGrades &&
                                                                            assessment.manualGrades.hasOwnProperty(this.state.selectedStudentId)) {
                                                                            let manualGrade = assessment.manualGrades[this.state.selectedStudentId]
                                                                            // no automatic grade, use manual grade as it exists
                                                                            // manual grade has same structure as studentGrade
                                                                            if (!studentGrade.graded && manualGrade.graded) {
                                                                                studentGrade = manualGrade
                                                                            }
                                                                        }
                                                                        if (!studentGrade.graded) {
                                                                            return false;
                                                                        }
                                                                        let correct = studentGrade.chosenAnswersBaseQuiz[idx];
                                                                        return <div key={'print-quiz-final-grade-idx-' + idx}>
                                                                            {idx === 0 ?
                                                                                <div className='mb-2 flex flex-v-center w-100'>
                                                                                    <div className='font-24 font-bold mr-1' style={{ color: '#1e293b' }}>Grade:</div>
                                                                                    <div className='font-20' style={{ color: '#475569' }}>{(studentGrade.finalGrade.grade * 100).toFixed(2)}%</div>
                                                                                </div> : ''}
                                                                            <div className='mb-2 flex flex-v-center w-100'>
                                                                                <div className='font-24 font-bold mr-1' style={{ color: '#1e293b' }}>Question {idx + 1}:</div>
                                                                                <div className='font-20' style={{ color: '#475569' }}>{correct ? 'Correct' : 'Incorrect'}</div>
                                                                            </div>
                                                                        </div>
                                                                    })}
                                                                </div> : ''}
                                                        </div>
                                                        <div className='print-background-fff print-student-resource'>
                                                            <StudentResource
                                                                htmlSource={assessment.quiz.docs}
                                                                disableSplitView={true} />
                                                        </div>
                                                    </div>
                                                    :
                                                    assessment && assessment.quiz.docs.map((lessonPlanItem, idx) => {
                                                        if (!this.state.selectedStudentId) {
                                                            return false
                                                        }
                                                        if (!(this.props.teacherBaseProps &&
                                                            this.props.teacherBaseProps.studentDict)) {
                                                            return false
                                                        }
                                                        if (!this.props.teacherBaseProps.studentDict.hasOwnProperty(this.state.selectedStudentId)) {
                                                            return false
                                                        }
                                                        const student = this.props.teacherBaseProps.studentDict[this.state.selectedStudentId]
                                                        let studentGrade = assessment.studentGrades[this.state.selectedStudentId]
                                                        if (assessment.hasOwnProperty('manualGrades') &&
                                                            assessment.manualGrades &&
                                                            assessment.manualGrades.hasOwnProperty(this.state.selectedStudentId)) {
                                                            let manualGrade = assessment.manualGrades[this.state.selectedStudentId]
                                                            // no automatic grade, use manual grade as it exists
                                                            // manual grade has same structure as studentGrade
                                                            if (!studentGrade.graded && manualGrade.graded) {
                                                                studentGrade = manualGrade
                                                            }
                                                        }
                                                        let assessmentCompleted = studentGrade.graded
                                                        if (!assessmentCompleted) {
                                                            return <div className='mt-50 text-center font-20' style={{ color: '#475569' }}>This student has not completed this assessment yet.</div>
                                                        }
                                                        let chosenAnswersBaseQuiz = studentGrade.chosenAnswersBaseQuiz
                                                        let chosenId = chosenAnswersBaseQuiz[lessonPlanItem.metadata.uuid]
                                                        let pageBreakInsideAvoid = idx > 0 ? 'page-break-inside-avoid ' : ''
                                                        return <div className={pageBreakInsideAvoid + 'font-black font-20 ant-shadow br-15 p-4 mb-50 print-remove-padding print-remove-border print-remove-shadow'} key={'assessment-idx-' + idx}>
                                                            <div className='font-24 print-mb-1 mb-2 font-bold' style={{ color: '#1e293b' }}>Question {idx + 1}</div>
                                                            <DocumentDelegator
                                                                document={{
                                                                    assessment: assessment,
                                                                    components: lessonPlanItem.components[0].question,
                                                                    metadata: lessonPlanItem.metadata,
                                                                }}
                                                            />
                                                            <div className='mt-2'></div>
                                                            {lessonPlanItem.components[0].answers.map((choice, choiceIndex) => {
                                                                let choseThisAnswer = choice.id === chosenId
                                                                let correct = choice.correct
                                                                let choiceLetter = 'A'
                                                                const choiceIndexPlusOne = choiceIndex + 1
                                                                if (choiceIndexPlusOne === 2) {
                                                                    choiceLetter = 'B'
                                                                } else if (choiceIndexPlusOne === 3) {
                                                                    choiceLetter = 'C'
                                                                } else if (choiceIndexPlusOne === 4) {
                                                                    choiceLetter = 'D'
                                                                }
                                                                return <div className='mb-1 font-20' key={'choice-' + (idx + 1) + '-' + choiceIndex}>
                                                                    <div className={'p-2 border br-4' + (correct ?
                                                                        ' border-success bg-light-green' : '') + (choseThisAnswer && !correct ?
                                                                            ' border-error bg-light-red' : '')}>
                                                                        {choseThisAnswer ?
                                                                            <div className='font-20 font-bold mb-2' style={{ color: '#1e293b' }}>{student.firstName} selected this answer:</div>
                                                                            : ''}
                                                                        <div className='flex w-100'>
                                                                            <div className='mr-2'>
                                                                                <div className='flex w-100 p-mb-0'>
                                                                                    <span className='mr-05'>{choiceLetter}.</span>
                                                                                    <DocumentDelegator
                                                                                        document={{
                                                                                            assessment: assessment.quiz.quiz,
                                                                                            components: choice.choice,
                                                                                            metadata: lessonPlanItem.metadata,
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div className='ml-auto'>
                                                                                {correct ?
                                                                                    <Icon type='check' className='text-success' />
                                                                                    : ''}
                                                                                {choseThisAnswer && !correct ?
                                                                                    <Icon type='close' className='text-danger' />
                                                                                    : ''}
                                                                            </div>
                                                                        </div>
                                                                        {correct || choseThisAnswer ?
                                                                            <div className='font-20 mt-2 pt-2 border-top'>
                                                                                <div className='font-bold' style={{ color: '#1e293b' }}>{'Why this answer is ' + (correct ? ' correct' : 'incorrect') + ':'}</div>
                                                                                <div className='p-mb-0'>
                                                                                    <DocumentDelegator
                                                                                        document={{
                                                                                            assessment: assessment.quiz.quiz,
                                                                                            components: Array.isArray(choice.reason) ? choice.reason : [choice.reason],
                                                                                            metadata: lessonPlanItem.metadata,
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            : ''}
                                                                    </div>
                                                                </div>
                                                            })}
                                                            {lessonPlanItem ?
                                                                <div className='mt-4 page-break-inside-avoid'>
                                                                    <div className='font-16 font-bold' style={{ color: '#1e293b' }}>
                                                                        Question is for standard: {lessonPlanItem.metadata.standard.standard}
                                                                    </div>
                                                                    {lessonPlanItem.metadata.standard.hasOwnProperty('isPriority') &&
                                                                        lessonPlanItem.metadata.standard.isPriority ?
                                                                        <div className='font-16' style={{ color: '#475569' }}>*Priority Standard</div>
                                                                        : ''}
                                                                    <div className='mt-1 font-16' style={{ color: '#475569' }}>{lessonPlanItem.metadata.standard.title}</div>
                                                                </div>
                                                                : ''}
                                                        </div>
                                                    })}
                                            </div>
                                        </div>
                                    </div> : ''}
                                {this.state.selectedKeys.length > 0 &&
                                    this.state.selectedKeys[0] === 'print-test' ?
                                    <div className='pl-2 pr-2'>
                                        <div className='relative mb-4'>
                                            <div className='w-100 br-20 overflow-hidden'
                                                style={{ height: '220px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }} />
                                            <div className='absolute-tl w-100 h-100 p-4 flex flex-v-center'>
                                                <div>
                                                    <div className='font-40 font-bold font-fff'>Print Quiz</div>
                                                    <div className='font-24 font-fff mt-1'>{assessmentTitle}</div>
                                                    {assessment && assessment.hasOwnProperty('timeStamp') &&
                                                        assessment.timeStamp &&
                                                        assessment.timeStamp.hasOwnProperty('seconds') ?
                                                        <div className='font-20 font-fff mt-1' style={{ opacity: 0.85 }}>{moment.utc(assessment.timeStamp.seconds * 1000).format("MM/DD/YYYY")}</div>
                                                        : ''}
                                                </div>
                                            </div>
                                        </div>
                                        {/* Friendly info banner */}
                                        <div style={{ display: 'flex', gap: 16, alignItems: 'center', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
                                            <Icon type='printer' style={{ fontSize: 34, color: '#2d6a9f' }} />
                                            <div>
                                                <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 2 }}>A paper copy of the quiz</div>
                                                <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.5 }}>Use this to print a blank version of the quiz for students to take on paper.</div>
                                            </div>
                                        </div>
                                        <div className='mt-2 pr-3'>
                                            <PrintableAssessment
                                                teacherBaseProps={this.props.teacherBaseProps}
                                                assessment={assessment}
                                                showAddAndRemoveGrade={true}
                                            />
                                        </div>
                                    </div> : ''}
                            </div>
                        </Layout.Content>
                    </Layout>
                </Layout>
                <div style={{ marginLeft: 270, }}>
                    <CustomFooter />
                </div>
            </div>
        )
    }
}

export default PacingGuideTeacherAssessment
